import { UnitSelectorService } from '@addins/core/unit-activity';
import { Injectable } from '@angular/core';
import { ActionSheetButton } from '@ionic/angular';
import { MenuEntry } from '@services/menu/entry.schema';
import { SideMenuService } from '@services/menu/side-menu.service';
import { AddinExecute, Execute, MyEquipmentService, MyEquipmentState } from '@techwan/ionic-core';
import { filter } from 'rxjs/operators';
import { QRCodeViewComponent } from '../../../views/qr-code-view/qr-code-view.component';
import { JoinUnitWithQRCodeService } from '../../join-unit-with-qr-code/join-unit-with-qr-code.service';

@AddinExecute({
  name: 'QRCodeSetup'
})
@Injectable({
  providedIn: 'root'
})
export class QRCodeSetupService extends Execute {
  private qrCodeMenuEntry: MenuEntry = null;
  private unitCreationButton: ActionSheetButton = null;

  constructor(
    private sideMenu: SideMenuService,
    private myEquipmentService: MyEquipmentService,
    private unitSelector: UnitSelectorService,
    private joinUnitWithQrCode: JoinUnitWithQRCodeService
  ) {
    super();
  }

  execute() {
    this.qrCodeMenuEntry = new MenuEntry('QRCode', 'qr-code', QRCodeViewComponent, 450);
    this.sideMenu.addMenuEntry(this.qrCodeMenuEntry);

    this.myEquipmentService.stateChanged.pipe(filter(state => state === MyEquipmentState.ready)).subscribe(() => this.onEquipmentReady());
  }

  private onEquipmentReady() {
    let device;
    let unit;
    this.myEquipmentService.myDevice.subscribe(d => (device = d)).unsubscribe();
    this.myEquipmentService.myUnit.subscribe(u => (unit = u)).unsubscribe();

    if (device !== null && unit === null) {
      if (!this.unitCreationButton) {
        this.unitCreationButton = this.unitSelector.createButton('Mobile.ScanQrCode', () => this.joinUnitWithQrCode.joinUnit());
      }
      this.unitSelector.addUnitCreationButton(this.unitCreationButton);
    }
  }
}
